import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffDesign = () => import('./staff/design')
const ViewStaffReportLog = () => import('./staff/log')
const ViewStaffConfiguration = () => import('./staff/configuration')

Vue.use(Router)

// reference (access.view_reference / m_modules_permissions.reference) ->
// nombre de ruta. Fuente única, ver router/viewsRegistry.js.
const VIEWS = {
  dashboard: 'ReportsStaffDashboard',
  design: 'ReportsStaffDesign',
  log: 'ReportsStaffReportLog',
  configuration: 'ReportsStaffConfiguration',
}

const router =
  [
    {
      path: '/st/reports',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: VIEWS.dashboard,
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Reportes',
          }          
        },                
        {
          path: 'design',
          name: VIEWS.design,
          component: ViewStaffDesign,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Diseño de reportes',
          }          
        },          
        {
          path: 'log',
          name: VIEWS.log,
          component: ViewStaffReportLog,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Log de impresiones',
          }          
        },
        {
          path: 'configuration',
          name: VIEWS.configuration,
          component: ViewStaffConfiguration,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Configuración de impresión',
          }
        },
      ]
    },
  ]

export default router
export { VIEWS }
